<template>
	<modal v-model="open">
		<template #header>
			<h2>Call Me About This Boat</h2>
			<p>Submit your estimate to <strong>{{ location?.dealer?.name }}</strong> to confirm that this boat is available, and a dealer representative will contact you shortly.</p>
			<div class="boat__details mt-[37px] relative">
				
				<div class="boat__reference">
					<b>{{ location?.dealer?.name }}</b><br/>
					{{ location.city }}, {{ location.state }}<br/>
					{{ boat.boat.model_year }} {{ boat.boat.name }}
				</div>
				<div class="boat__image">
					<img :src="image" alt="">
				</div>
			</div>
		</template>
		<loader :loading="loading" class="modal-loader"></loader>
		<form action="" method="post" class="space-y-[24px] mt-5" @submit.prevent="send" v-if="!sent">
			<div class="text-[12px] mt-[7px]">*Required</div>
			<input-text v-model="call.firstname" label="First Name" :required="true" :errors="errors.firstname"></input-text>
			<input-text v-model="call.lastname" label="Last Name" :required="true" :errors="errors.lastname"></input-text>
			<input-text v-model="call.email" label="Email" :required="true" :errors="errors.email" inputmode="email"></input-text>
			<input-text v-model="call.phone" label="Phone" :required="true" :errors="errors.phone" inputmode="tel" v-mask="'(###) ###-####'"></input-text>
			<div class="form__group">
				<div class="field__group">
					<input type="submit" value="Call Me About This Boat" />
				</div>
			</div>
		</form>
		<div class="form__notes text-[12px] mt-8" v-if="!sent">
			By clicking "Submit", you authorize Nauticstar Boats and its dealers to contact you with marketing and sales information by emailing or calling or texting the phone number provided. This authorization is not required to make a purchase, please see our <a href="https://nauticstarboats.com/privacy-policy/" target="_blank">Privacy Policy.</a>
		</div>
		<div v-if="sent" class="space-y-[24px] mt-5 mb-5 success-text">
			Thank you for your interest. We're excited to place you in the perfect Nauticstar boat. Your local certified dealer will contact you shortly.
		</div>
	</modal>
</template>

<script>
	export default {
		props: ['value', 'boat'],
		data() {
			return {
				open: this.value,
				call: {},
				errors: {},
				loading: false,
				sent: false
			};
		},
		computed: {
			location() {
				return this.$store.state.location;
			},
			image() {
				if(!this.boat) {
					return '/images/front/BMT.png';
				}
				if(this.boat.featured_image && this.boat.featured_image.thumb600) {
					return this.boat.featured_image.thumb600;
				}
				if(this.boat.boat && this.boat.boat.featured_image && this.boat.boat.featured_image.thumb600) {
					return this.boat.boat.featured_image.thumb600;
				}
				return '/images/front/BMT.png';
			}
		},
		watch: {
			value() {
				this.open = this.value;
			},
			open() {
				this.$emit('input', this.open);
			}
		},
		methods: {
			async send() {
				this.errors = {};
				this.loading = true;
				try {
					await this.$post('/json/boats/' + this.boat.id + '/call', this.call);
					this.call = {};
					this.sent = true;
				} catch(e) {
					this.errors = e.data || {}
				}
				this.loading = false;
			}
		}
	}
</script>